import EventEmitter from '../../utils/event-emitter/EventEmitter'

export class ErrorLogger {
  protected _eventEmitter: EventEmitter<ErrorType>
  protected _debug: boolean

  constructor() {
    this._eventEmitter = new EventEmitter()
    this._debug = true
  }

  error(error: ErrorType): void {
    this._eventEmitter.emit('error', error)
    if (this._debug) {
      console.error(error)
    }
  }

  warning(error: ErrorType): void {
    this._eventEmitter.emit('warning', error)
    if (this._debug) {
      console.warn(error)
    }
  }

  get on() {
    return this._eventEmitter.on.bind(this._eventEmitter)
  }
}

export type ErrorType = unknown
